import { useInfiniteQuery } from "@tanstack/react-query";
import api from "../axios-client";

export const useGetSingleDeviceAttribute = (deviceId: string, attributeId: string) => {
    return useInfiniteQuery({
        queryKey: ["devices", deviceId, "attributes", attributeId],
        queryFn: async ({ pageParam = 0 }) => {
            const response = await api.get(
                `/api/v1/devices/${deviceId}/attributes/${attributeId}`,
                {
                    params: {
                        offset: pageParam,
                    },
                }
            );
            return response.data.data;
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages) => {
            return lastPage.length === 0 ? undefined : allPages.length * 10; // Adjust based on API behavior
        },
        retry: false,
    });
};
